<template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Client</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form1"
              v-model="valid1"
            >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="client.name"
                  label="Client Name"
                  type="text"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.email"
                  label="Client Email"
                  type="email"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.mobile"
                  label="Mobile No"
                  type="number"
                ></v-text-field>
              </v-col>
               <v-col cols="12">
                <v-text-field
                  v-model="client.gst"
                  label="Client Gst No"
                  type="text"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="client.address"
                  label="Client Address"
                  type="text"
                ></v-text-field>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1"  @click="addclient1()">Save</v-btn>
        </v-card-actions>
      </v-card>
</template>

<script>
import { mapActions } from 'vuex';
  export default {
    data: function() {
      return {
        vaild1: true,
        client: {
            name : '',
            email: '',
            mobile: '',
            gst: '',
            address: '',
        },
        emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
      }
    },
    methods:{
      ...mapActions(['addclient']),
      addclient1() {
        if(this.$refs.form1.validate())
        {
          this.addclient(this.client);
          this.$refs.form1.reset();
        }
      }
    }
  }
</script>